import { useCallback } from "react";
import { useParams } from "react-router-dom";
import {
  mapLanguageCodesToInfo,
  useLanguages,
} from "../context/LanguagesContext";
import { usePortal } from "../context/PortalsContext";
import { useTranslation } from "../context/TranslationContext";
import { useAuth } from "../context/AuthContext";
import { getBootstrap } from "../services/api/apiClient";

export const useAppBootstrap = () => {
  const { portalUid: urlPortalUid } = useParams();
  const { dispatch: authDispatch } = useAuth();
  const { dispatch: portalsDispatch } = usePortal();
  const { dispatch: languagesDispatch } = useLanguages();
  const { dispatch: translationsDispatch } = useTranslation();

  return useCallback(async (): Promise<void> => {
    const storedPortalUid =
      urlPortalUid || localStorage.getItem("selectedPortal") || undefined;
    const storedLang = localStorage.getItem("selectedLanguage") || undefined;

    const response = await getBootstrap({
      portalId: storedPortalUid,
      langCode: storedLang,
    });

    const selectedPortal =
      response.portals.find(
        (p) => p.portalUid === (storedPortalUid ?? response.user.PortalUid),
      ) ?? response.portals[0];

    const portalLangs =
      selectedPortal?.portalLanguages.map((l) => l.languageCode) ?? [];
    const selectedLanguage =
      (storedLang && portalLangs.includes(storedLang) && storedLang) ||
      selectedPortal?.portalLanguages.find((l) => l.isDefault)?.languageCode ||
      "en";

    authDispatch({ type: "SET_USER", payload: response.user });
    portalsDispatch({ type: "SET_PORTALS", payload: response.portals });
    if (selectedPortal) {
      portalsDispatch({ type: "SET_SELECTED_PORTAL", payload: selectedPortal });
    }
    languagesDispatch({
      type: "SET_LANGUAGES",
      payload: mapLanguageCodesToInfo(response.languages),
    });
    languagesDispatch({
      type: "SET_SELECTED_LANGUAGE",
      payload: selectedLanguage,
    });
    translationsDispatch({ type: "SET_ALL", payload: response.translations });
  }, [
    authDispatch,
    portalsDispatch,
    languagesDispatch,
    translationsDispatch,
    urlPortalUid,
  ]);
};
